import { customElement } from 'lit/decorators.js';
import { defaultStagedThreshold, EventCancellation } from '../../../../webmodule-common/other/general/staged-event';
import { FranchiseePurchaseOrderSummaryTable } from './franchisee-purchase-order-summary-table';
import { notificationSignal } from '../../../../webmodule-common/other/ui/icons/icon-notification-signal';
import { PurchaseOrderListView } from '../../../purchase-orders/views/purchase-order-list-view';
import {
  PurchaseOrderSummaryTable,
  PurchaseOrderSummaryTableOptions
} from '../../../purchase-orders/views/purchase-order-summary-table';
import { SSEOrder } from '../../../purchase-orders/data/sse-order';
import { stagedExecution } from '../../../../webmodule-common/other/general/event-source-client';
import { WMEventSource } from '../../../api/event-source';

@customElement('wm-franchiseepurchaseorderlistview')
export class FranchiseePurchaseOrderListView extends PurchaseOrderListView {
  //this can be overridden in subclass to replace the table with different column/view etc
  protected purchaseOrderSummaryTableFactory(options: PurchaseOrderSummaryTableOptions): PurchaseOrderSummaryTable {
    return new FranchiseePurchaseOrderSummaryTable(options);
  }

  afterRefresh() {
    this._eventCancel.cancel();
  }
  async dispose(): Promise<void> {
    await super.dispose();
    this._eventCancel.cancel();
  }
  private _eventCancel: EventCancellation = new EventCancellation();
  private _eventOrderUpdated = stagedExecution({
    threshold: defaultStagedThreshold,
    cancelToken: this._eventCancel,
    eventFinally: () => notificationSignal(false),
    event: async () => {
      this.updatePageTotals();
      this.tables.forEach(t => (t.dataIsStale = true));
      const table = this.tabManager.activePage?.data as PurchaseOrderSummaryTable;
      this.staleOrders = [];
      if (table) {
        await table.refreshData();
        table.dataIsStale = false;
      }
      //reload the page.. we dont know what moved, or where, or what state its in
    },
    eventTriggered: (_data: SSEOrder) => {
      notificationSignal(true);
    },
    eventActioned: (data: SSEOrder) => {
      if (!this.staleOrders.includes(data.id)) this.staleOrders.push(data.id);
      const table = this.tabManager.activePage?.data as PurchaseOrderSummaryTable;
      table.refreshData();
    }
  });

  connectedCallback(): void {
    super.connectedCallback();
    WMEventSource.getInstance().addEventListener(WMEventSource.order, this._eventOrderUpdated);
  }
  disconnectedCallback(): void {
    super.disconnectedCallback();
    WMEventSource.getInstance().removeEventListener(WMEventSource.order, this._eventOrderUpdated);
  }
}
